import { z } from 'zod';

export const zodCompanyInvoiceReceiversResponseSchema = z.object({
  invoiceReceivers: z.array(z.string()),
});
